import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';

import { PromotionHistory } from './components/PromotionHistory/index_new';
import { RecentPromotionsList } from './components/RecentPromotionsList/index_new';
import { TopSignatureSources } from './components/TopSignatureSources';
import { usePetitionInsights } from './hooks/usePetitionInsights';

export function PetitionInsights(): JSX.Element | null {
	const { data } = usePetitionInsights();

	if (!data.shouldShowPetitionInsights) return null;

	return (
		<section aria-labelledby="petition-insights-title" role="group" data-qa="promotion-insights">
			{data.shouldShowSignatureSources && (
				<Card mt="16px" backgroundColor="white" sx={{ border: 'unset', borderRadius: 'big' }}>
					<TopSignatureSources />
				</Card>
			)}
			{data.shouldShowPromotionStats && (
				<div className="bg-background-base flex flex-col gap-6 py-8 md:py-12">
					<PromotionHistory />
					<RecentPromotionsList />
				</div>
			)}
		</section>
	);
}
